import axios from 'axios';

const LOOKUP_URL = `/api/lookup`;
export const DO_LOOKUP = 'DO_LOOKUP';
export const RECEIVE_LOOKUP = 'RECEIVE_LOOKUP';
export const DO_LOOKUP_ERROR = 'DO_LOOKUP_ERROR';
export const doLookup = () => async (dispatch) => {
  dispatch({ type: DO_LOOKUP });
  try {
    let res = await axios.get(LOOKUP_URL);
    dispatch({ type: RECEIVE_LOOKUP, payload: res?.data });
  } catch (error) {
    dispatch({ type: DO_LOOKUP_ERROR });
  }
};